import { useMutation } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const deleteAppointment = (axios) => async (id = "", isOpenAppointment) => {
  const url = isOpenAppointment ? `/api/v1/internal/open-appointments/${id}` : `/api/v1/internal/appointments/${id}`;
  const { data } = await axios.delete(url);
  return data;
};
const useDeleteAppointment = ({ id, isOpenAppointment }) => {
  const { echoCore } = useAxiosProvider();
  const mutation = useMutation({
    mutationFn: () => deleteAppointment(echoCore)(id, isOpenAppointment)
  });
  return mutation;
};
export {
  useDeleteAppointment
};
